// extracted by mini-css-extract-plugin
export default {"textarea":"insert-text_textarea__mB9h2","slider-input":"insert-text_slider-input__blO-J"};